import { nioJsBridge } from '@nio-wad/universal-bridge-h5'
import { showToast } from '@nio-fe/horo-h5'
// import { Env } from '@loca/mfe-utils'
import { getEnv } from '@nio-wad/hooks'

const connectWebSocket = async (ws: any) => {
  return new Promise((resolve) => {
    // 监听当前 uuid 是否有 live 页面上报
    nioJsBridge.monitorLiving(ws.wsConfig.env, ws.wsConfig.uuid, () => {
      resolve('success')
    })
  })
}

export const initUniversalFun = async () => {
  const env = getEnv()
  let res
  if (nioJsBridge.currentInMPContainer()) {
    // 不传 env默认是prod环境.(dev,test,stg,prod)
    if (env !== 'local' && ['dev', 'stg', 'test', 'prod'].includes(env)) {
      console.log('getWSConnect---env', env)
      res = nioJsBridge.getWSConnect(env)
    } else {
      res = nioJsBridge.getWSConnect('test')
    }
  }
  const result = await connectWebSocket(res)
  console.log('===============connectWebSocket=====================')
  console.log('result', result)
  console.log('====================================')
  if (result === 'success') {
    console.log('================小程序WS链接成功====================')
    console.log()
    console.log('====================================')
  } else {
    // todo
    showToast({ content: '网络异常，请稍后再试！' })
    console.log('error', result)
  }
}
